import { AppWindow, FileCode, MonitorSmartphone } from 'lucide-solid';
import { Match, mergeProps, Switch } from 'solid-js';
import { EApplicationType } from '~/api';
import { MultiApplicationFlowType } from './utils';

type MultiAppIconsProps = {
  applicationType: EApplicationType;
  flowType?: MultiApplicationFlowType;
};

export default function MultiAppIcons(props: MultiAppIconsProps) {
  const merged = mergeProps(
    {
      flowType: MultiApplicationFlowType.NEW_APPLICATION
    },
    props
  );

  const getCommonContainerClass = () => {
    return {
      'w-6 h-6': merged.flowType === MultiApplicationFlowType.NEW_APPLICATION,
      'w-10 h-10': merged.flowType === MultiApplicationFlowType.EDIT_APPLICATION
    };
  };

  const getCommonIconProps = () => {
    return {
      class: `w-full h-full`,
      strokeWidth: '1'
    };
  };

  return (
    <Switch>
      <Match
        when={merged.applicationType === EApplicationType.DEFAULT_APPLICATION}
      >
        <div
          class={'flex items-center justify-center'}
          classList={getCommonContainerClass()}
        >
          <AppWindow {...getCommonIconProps()} />
        </div>
      </Match>
      <Match when={merged.applicationType === EApplicationType.WEB_APPLICATION}>
        <div
          class={'flex items-center justify-center'}
          classList={getCommonContainerClass()}
        >
          <AppWindow {...getCommonIconProps()} />
        </div>
      </Match>
      <Match
        when={
          merged.applicationType === EApplicationType.SINGLE_PAGE_APPLICATION
        }
      >
        <div
          class={'flex items-center justify-center'}
          classList={getCommonContainerClass()}
        >
          <FileCode
            {...getCommonIconProps()}
            absoluteStrokeWidth={true}
          />
        </div>
      </Match>
      <Match
        when={merged.applicationType === EApplicationType.NATIVE_APPLICATION}
      >
        <div
          class={'flex items-center justify-center'}
          classList={getCommonContainerClass()}
        >
          <MonitorSmartphone {...getCommonIconProps()} />
        </div>
      </Match>
    </Switch>
  );
}
